module.exports = __webpack_public_path__ + "static/media/1007138.a9d578be.jpg";